import { HttpRequest } from './HttpRequest';
import { quotationUrl, baseUrl } from 'utils/ApiRoutes';
import { IMetricsResponse } from 'types/Metrics';

/**
 * Get dashboard metrics
 * @param startDate - Optional start date in format 'yyyy-MM-dd'
 * @param endDate - Optional end date in format 'yyyy-MM-dd'
 * @returns Promise with metrics data
 */
export const getMetrics = async (
  startDate?: string,
  endDate?: string
): Promise<IMetricsResponse> => {
  try {
    const params = new URLSearchParams();

    if (startDate?.trim()) params.append('startDate', startDate);
    if (endDate?.trim()) params.append('endDate', endDate);

    const queryString = params.toString();
    const url = `${baseUrl}${quotationUrl.metrics}${queryString ? `?${queryString}` : ''}`;

    const response = await new HttpRequest().Get<IMetricsResponse>(url);
    return response.data;
  } catch (error) {
    if (error instanceof Error) {
      throw new Error(error.message);
    }
    throw new Error('Error al obtener las métricas del dashboard');
  }
};
